/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import AnomalyRecordList from './AnomalyRecordList';
import InspectionRouteList from './InspectionRouteList';
import { Card } from 'react-bootstrap';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import ThermalRecordList from './ThermalRecordList';
import InspectionRecordsTable from './InspectionRecord/InspectionRecordsTable';
import { useTranslation } from 'react-i18next';

const TabListContainer = () => {
    const { t } = useTranslation();
    const tt = (key: string) => t(key, { ns: 'translation' });
    const [searchParams, setSearchParams] = useSearchParams();
    const [key, setKey] = useState<string | null>(searchParams.get('tab') ?? 'inspection-route');
    const navigate = useNavigate();

    useEffect(() => {
        const tabParam = searchParams.get('tab');
        if (tabParam && tabParam !== key) {
            setKey(tabParam);
        }
    }, [searchParams, key]);

    const handleTabSelect = (k: string | null) => {
        setKey(k);
        if (!k) return;

        const newParams = new URLSearchParams(searchParams);
        newParams.set('tab', k);
        setSearchParams(newParams, { replace: true });
    };

    const handleCreate = () => {
        let path = ''
        switch (key) {
            case "anomaly-record":
                path = 'thermalAnomalyForm'
                break;
            case "inspection-route":
                path = 'inspectionrouteForm'
                break;

            case "thermographic-record":
                path = 'thermalRecordForm'
                break;

            default:
                break;
        }

        if (path != '')
            navigate(`${path}/new`)
    }

    return (
        <Card className="h-100">
            <Card.Body>
                <Tab.Container
                    id="controlled-tab-example"
                    activeKey={key ?? undefined}
                    onSelect={handleTabSelect}
                >
                    <Nav variant="underline" className="mb-3 ">
                        <Nav.Item>
                            <Nav.Link eventKey="inspection-route" className='nav-item-record'>
                                {tt('pages.thermography.tabs.inspectionRecords')}
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="anomaly-record" className='nav-item-record'>
                                {tt('pages.thermography.tabs.anomalyMonitoringRecords')}
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="thermographic-record" className='nav-item-record'>
                                {tt('pages.thermography.tabs.thermographicRecords')}</Nav.Link>
                        </Nav.Item>

                        {key != "inspection-route" && (
                            <Button
                                className="ms-auto"
                                onClick={() => handleCreate()}
                            >
                                {tt('pages.thermography.tabs.createRecord')}
                            </Button>
                        )}
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane eventKey="anomaly-record">
                            <AnomalyRecordList />
                        </Tab.Pane>
                        <Tab.Pane eventKey="inspection-route">
                            <InspectionRecordsTable />
                        </Tab.Pane>
                        <Tab.Pane eventKey="thermographic-record">
                            <ThermalRecordList />
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </Card.Body>
        </Card>
    )
}

export default TabListContainer;
